module.exports = __webpack_public_path__ + "static/media/h.51504957.svg";